let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dsU72")).then(() => parcelRequire('6keru'));